export default "__VITE_ASSET__Bs_1AHd0__"